module.exports =
  '_PAYMENT':
    'INTRO':
      'TITLE': 'Upgrade'
      'BUTTON_SPECIAL': 'Special member'
      'BUTTON_SPECIAL_HINT': '$5.00 per month (tax excluding)'
      'TITLE1': 'To use this feature, you must be registered as a paid-member.'
      'TITLE2': 'Analyze your abilities with more features!'
      'TITLE3': 'When you register as a paid-member ($5.00 USD/mo.), you can use more detailed score analyses/course analyses to improve your game.'
      'CONTENT1': 'Set your target'
      'CONTENT2': 'Compare your scores, course-by-course'
      'CONTENT3': 'Edit scores from your PC'
      'DESCRIPTION1': 'Input your individual target data to improve upon your goals quickly and efficiently'
      'DESCRIPTION2': 'Compare your personal round results with the course average'
      'DESCRIPTION3': 'You can also edit your scoring data on your PC after you have entered it in the mobile app'
    'WEB_CANCEL':
      'HEADER': 'Upon terminating your paid-membership, you will lose the ability to use the following functions.'
      'TITLE': 'Features only available through paid-membership'
      'TEXT_CONTENT_PART1': 'To cancel your membership, please press the "Unsubscribe" button below.'
      'TEXT_CONTENT_PART2': 'For those who would like to continue using the features only provided through paid-membership, please press the "Close" button below.'
    'APP_CANCEL':
      'HEADER' : '[ATTENTION PLEASE]'
      'HEADER_TEXT1' : 'When you process the cancellation procedure, from that date, you will not be able to use the paid service anymore.'
      'HEADER_TEXT2' : 'Please be careful on that.'

      'EXPLAIN' : 'From the Web Service version as well as the Application version, the customer can not process the cancellation procedure for the paid membership.'
      'EXPLAIN_TEXT1' : 'Because the Google Play or Apple ID has been already registered to the paid subscribers,'
      'EXPLAIN_TEXT2' : 'you will therefore need to unsubscribe on each platform.'

      'LIST' : 'Please follow the manual as below.'

      'GOOGLE_HEADER': '【If you use Google Play】'
      'GOOGLE_TEXT1' : 'From Google Play,'
      'GOOGLE_TEXT2' : 'Please open the GOLF NETWORK PLUS Application screen,'
      'GOOGLE_TEXT3' : 'then execute the cancellation of subscription that will appear on the screen.'

      'APPLE_HEADER' : '【If you use Apple ID Billing】'
      'APPLE_TEXT1' : 'From App Store,'
      'APPLE_TEXT2' : 'Recommendation > Apple ID (Login) > Subscription Management'
      'APPLE_TEXT3' : 'Please follow the cancellation procedure as describe above.'
    'TV_CANCEL':
      'HEADER': '[ATTENTION PLEASE]'
      'HEADER_TEXT1' : 'When you process the cancellation procedure, from that date, you will not be able to use the paid service anymore.'
      'HEADER_TEXT2' : 'Please be careful on that.'

      'DESCRIPTION1' : 'Because you are registering to the paid membership on GN+ TV Web Service,'
      'DESCRIPTION2' : 'Please process the cancellation procedure from the following link'
      'DESCRIPTION3' : 'Process the cancellation ( It will transition to GN+ TV Web Service)'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/i18n/en.coffee